import  { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { Bar } from "react-chartjs-2";
import CustomTooltip from "../Buttons/CustomTooltip";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

// Register ChartJS components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

// Helper function to convert time string to seconds
const timeToSeconds = (timeStr) => {
  if (!timeStr) return 0;
  const parts = timeStr.split(":");
  if (parts.length === 3) {
    return (
      parseInt(parts[0]) * 3600 + parseInt(parts[1]) * 60 + parseInt(parts[2])
    );
  }
  return 0;
};

// Card Components
// Card Components - Updated to match SummaryDBMigration styling
const ExecutionStatusCard = ({ jobStatus, loading }) => (
  <div
    className="card border-0 card-migration mb-1"
    style={{ borderRadius: "8px", minHeight: "124px" }}
  >
    <div className="card-body p-3">
      <div className="d-flex justify-content-between align-items-start">
        <div>
          <div className="d-flex align-items-center">
            <img
              src="/assets/images/Execution_Status.jpg"
              alt="Execution Status"
              width="32px"
              height="32px"
              className="custom-me-3 card_image-styles"
            />
            <h5
              className="card-title fw-bold mb-0 dbcardsdesign"
              style={{
                height: "35px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              Execution Status
            </h5>
          </div>
          {loading ? (
            <div className="spinner-border spinner-border-sm text-secondary"></div>
          ) : (
            <h4 className="mb-2 mt-2 homecardfont">
              {jobStatus ?? "Status unavailable"}
            </h4>
          )}
          <h6 className="text-muted mb-1" style={{ fontSize: "12px", whiteSpace: "nowrap" }}>
            Current job status
          </h6>
        </div>
      </div>
    </div>
  </div>
);

const TotalFilesCard = ({ total, processed, loading }) => (
  <div
    className="card border-0 card-migration mb-1"
    style={{ borderRadius: "8px", minHeight: "124px" }}
  >
    <div className="card-body p-3">
      <div className="d-flex justify-content-between align-items-start">
        <div>
          <div className="d-flex align-items-center">
            <img
              src="/assets/images/Total files count.jpg"
              alt="Total files"
              width="32px"
              height="32px"
              className="custom-me-3 card_image-styles"
            />
            <h5
              className="card-title fw-bold mb-0 dbcardsdesign"
              style={{
                height: "35px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              Total Files Count
            </h5>
          </div>
          {loading ? (
            <div className="spinner-border spinner-border-sm text-secondary"></div>
          ) : (
            <h4 className="mb-2 mt-2 homecardfont">
              {total ?? "N/A"}
            </h4>
          )}
          <h6 className="text-muted mb-1" style={{ fontSize: "12px" }}>
            Total files processed
          </h6>
        </div>
      </div>
    </div>
  </div>
);

const SuccessFilesCard = ({ count, loading }) => (
  <div
    className="card border-0 card-migration mb-1"
    style={{ borderRadius: "8px", minHeight: "124px" }}
  >
    <div className="card-body p-3">
      <div className="d-flex justify-content-between align-items-start">
        <div>
          <div className="d-flex align-items-center">
            <img
              src="/assets/images/Success Files count.jpg"
              alt="Success files"
              width="32px"
              height="32px"
              className="custom-me-3 card_image-styles"
            />
            <h5
              className="card-title fw-bold mb-0 dbcardsdesign"
              style={{
                height: "35px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              Success Files Count
            </h5>
          </div>
          {loading ? (
            <div className="spinner-border spinner-border-sm text-secondary"></div>
          ) : (
            <h4 className="mb-2 mt-2 homecardfont">
              {count ?? "N/A"}
            </h4>
          )}
          <h6 className="text-muted mb-1" style={{ fontSize: "12px" }}>
            Files converted successfully
          </h6>
        </div>
      </div>
    </div>
  </div>
);

const FailedFilesCard = ({ count, loading }) => (
  <div
    className="card border-0 card-migration mb-1"
    style={{ borderRadius: "8px", minHeight: "124px" }}
  >
    <div className="card-body p-3">
      <div className="d-flex justify-content-between align-items-start">
        <div>
          <div className="d-flex align-items-center">
            <img
              src="/assets/images/Failed Files count.jpg"
              alt="Failed files"
              width="32px"
              height="32px"
              className="custom-me-3 card_image-styles"
            />
            <h5
              className="card-title fw-bold mb-0 dbcardsdesign"
              style={{
                height: "35px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              Failed Files Count
            </h5>
          </div>
          {loading ? (
            <div className="spinner-border spinner-border-sm text-secondary"></div>
          ) : (
            <h4 className="mb-2 mt-2 homecardfont">
              {count ?? "N/A"}
            </h4>
          )}
          <h6 className="text-muted mb-1" style={{ fontSize: "12px" }}>
            Files that failed to convert
          </h6>
        </div>
      </div>
    </div>
  </div>
);

const ConversionRateCard = ({ rate, loading }) => (
  <div
    className="card border-0 card-migration mb-1"
    style={{ borderRadius: "8px", minHeight: "124px" }}
  >
    <div className="card-body p-3">
      <div className="d-flex justify-content-between align-items-start">
        <div>
          <div className="d-flex align-items-center">
            <img
              src="/assets/images/Conversion rate.jpg"
              alt="Conversion rate"
              width="32px"
              height="32px"
              className="custom-me-3 card_image-styles"
            />
            <h5
              className="card-title fw-bold mb-0 dbcardsdesign"
              style={{
                height: "35px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              Conversion Rate
            </h5>
          </div>
          {loading ? (
            <div className="spinner-border spinner-border-sm text-secondary"></div>
          ) : (
            <h4 className="fw-bold mb-2 mt-2 homecardfont">
              {rate ? `${rate}` : "N/A"}
            </h4>
          )}
          <h6 className="text-muted mb-1" style={{ fontSize: "12px" }}>
            Success rate of file conversion
          </h6>
        </div>
      </div>
    </div>
  </div>
);

// Main ViewReportsPage component
const ViewReportsPage = () => {
  const location = useLocation();
  const job_id = location.state?.jobId;
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isMaximized, setIsMaximized] = useState(false);
  const chartRef = useRef(null);
  const hideTimeoutRef = useRef(null);
  const [barWidth, setBarWidth] = useState(15);
  const chartContainerRef = useRef(null);

  useEffect(() => {
    if (job_id) {
      fetchReportData(job_id);
    } else {
      setError("No job ID provided");
    }
  }, [job_id]);

  const fetchReportData = async (job_id) => {
     const apiBaseReport = process.env.REACT_APP_API_URL_CODE_CONVERSION;
    const authToken = sessionStorage.getItem("access_token");

    if (!authToken) {
      console.error("Authentication token is missing.");
      setError("Please login to access this resource");
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const urlResponse = await fetch(
        `${apiBaseReport}/job_report/${job_id}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            Accept: "application/json",
          },
        }
      );

      if (!urlResponse.ok) {
        throw new Error(`Failed to get report data: ${urlResponse.status}`);
      }

      const reportData = await urlResponse.json();
      console.log("Report Data:", reportData);

      setReportData(reportData);
    } catch (err) {
      console.error("API Error:", err);

      if (err.name === "AbortError") {
        console.log("Request was aborted");
      } else if (err.message.includes("401")) {
        setError("Session expired - please login again");
        sessionStorage.removeItem("access_token");
      } else {
        setError(err.message);
      }
    } finally {
      setLoading(false);
    }
  };

  const toggleMaximize = () => {
    setIsMaximized((prev) => !prev);
    setTimeout(() => {
      if (chartRef.current) {
        const chartInstance = chartRef.current;
        chartInstance.update();
        chartInstance.resize();
      }
    }, 100);
  };

  const renderChart = () => {
    if (!reportData?.bar_chart?.chart_data) {
      return (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "100%" }}
        >
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      );
    }

    const fileCount = reportData.bar_chart.chart_data.length;
    const showScrollbar = fileCount > 10;

    // Create dataset with different colors based on file_status
    const chartData = {
      labels: reportData.bar_chart.chart_data.map(
        (item, index) =>
          item.file_name.replace(".sql", "") || `File ${index + 1}`
      ),
      datasets: [
        {
          label: `Execution Time (${reportData.bar_chart.unit})`,
          data: reportData.bar_chart.chart_data.map(
            (item) => item.execution_time
          ),
          backgroundColor: reportData.bar_chart.chart_data.map((item) =>
            item.file_status === "Failed" ? "#fdd2d1" : "#ABE9AA"
          ),
          borderColor: reportData.bar_chart.chart_data.map((item) =>
            item.file_status === "Failed" ? "#fdd2d1" : "#ABE9AA"
          ),
          borderWidth: 1,
          borderRadius: 4,
          barThickness: barWidth,
          categoryPercentage: 1.0,
          barPercentage: 1.0,
        },
      ],
    };

    const chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
    
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          enabled: false,
          external: (context) => {
            let tooltipEl = document.getElementById("chartjs-tooltip");

            // Create tooltip if doesn't exist
            if (!tooltipEl) {
              tooltipEl = document.createElement("div");
              tooltipEl.id = "chartjs-tooltip";
              tooltipEl.className = "custom-chart-tooltip";
              document.body.appendChild(tooltipEl);
            }

            // Hide if no tooltip
            if (context.tooltip.opacity === 0) {
              tooltipEl.style.opacity = "0";
              return;
            }

            // Set tooltip content
            if (context.tooltip.body) {
              const fileData = reportData?.["card_and_summary data"]?.files;
              const currentFile =
                reportData.bar_chart.chart_data[
                  context.tooltip.dataPoints[0].dataIndex
                ];

              const formatDate = (dateStr) => {
                if (!dateStr) return "N/A";
                try {
                  const [datePart] = dateStr.split(" ");
                  const [day, month, year] = datePart.split("-");
                  const monthNames = [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Oct",
                    "Nov",
                    "Dec",
                  ];
                  return `${parseInt(day)} ${monthNames[parseInt(month) - 1]}`;
                } catch (e) {
                  return "N/A";
                }
              };

              const fullName = currentFile?.file_name || "";
              const executionTime = context.tooltip.dataPoints[0].parsed.y;
              const status = currentFile?.file_status || "Unknown";
              const fileIndex = context.tooltip.dataPoints[0].dataIndex;
              const specificFileData = fileData?.[fileIndex];
              const startedAt = formatDate(specificFileData?.started_at);
              const completedAt = formatDate(specificFileData?.completed_at);

              tooltipEl.innerHTML = `
                <div class="tooltip-title">${fullName.replace(".sql", "")}</div>
                <div class="tooltip-content">Time: ${executionTime} ${
                reportData.bar_chart.unit
              }</div>
                <div class="tooltip-content">Status: ${status}</div>
                ${
                  startedAt !== "N/A" && completedAt !== "N/A"
                    ? `<div class="tooltip-content">Duration: ${startedAt} - ${completedAt}</div>`
                    : ""
                }
                <div class="tooltip-arrow"></div>
              `;
            }

            const position = context.chart.canvas.getBoundingClientRect();
            const tooltipWidth = tooltipEl.offsetWidth;
            const tooltipHeight = tooltipEl.offsetHeight;

            // Determine position
            let left = position.left + context.tooltip.caretX;
            let top = position.top + context.tooltip.caretY;
            let tooltipPosition = "right";

            // Default to right position
            left += 10;
            top -= tooltipHeight / 2;

            // Adjust if near right edge
            if (left + tooltipWidth > window.innerWidth) {
              left = position.left + context.tooltip.caretX - tooltipWidth - 10;
              tooltipPosition = "left";
            }

            // Adjust if near top edge
            if (top < 0) {
              top = 10;
              tooltipPosition += "-bottom";
            }

            // Adjust if near bottom edge
            if (top + tooltipHeight > window.innerHeight) {
              top = window.innerHeight - tooltipHeight - 10;
              tooltipPosition += "-top";
            }

            // Apply final position
            tooltipEl.style.left = `${left}px`;
            tooltipEl.style.top = `${top}px`;
            tooltipEl.style.opacity = "1";
            tooltipEl.className = `custom-chart-tooltip tooltip-${tooltipPosition}`;
          },
        },
      },
      hover: {
        mode: "nearest",
        intersect: false,
        animationDuration: 0,
      },
      onHover: (event, elements) => {
        const canvas = event.native?.target;
        if (canvas) {
          canvas.style.cursor = elements.length > 0 ? "pointer" : "default";

          // Keep tooltip visible if hovering over it
          const tooltip = document.getElementById("chartjs-tooltip");
          if (tooltip && tooltip.contains(event.native.target)) {
            tooltip.style.opacity = "1";
            if (hideTimeoutRef.current) {
              clearTimeout(hideTimeoutRef.current);
            }
          }
        }
      },

      scales: {
        y: {
          beginAtZero: true,
          title: {
            display: true,
            text: `Time (${reportData.bar_chart.unit})`,
            font: { weight: "bold" },
          },
          grid: {
            drawBorder: false,
            color: "rgba(0, 0, 0, 0.05)",
          },
        },
        x: {
          grid: {
            display: false,
            drawBorder: false,
          },
          ticks: {
            autoSkip: false,
            maxRotation: 0,
            minRotation: 0,
            font: { size: isMaximized ? 12 : 10 },
            callback: function (value) {
              return `File ${value + 1}`;
            },
          },
        },
      },
      animation: {
        duration: 300,
        onComplete: () => {
          if (chartRef.current) {
            chartRef.current.update();
          }
        },
      },
    };

    return (
      <div
        ref={chartContainerRef}
        style={{
          height: isMaximized ? "calc(100vh - 100px)" : "350px",
          width: "100%",
          position: "relative",
          transition: "height 0.3s ease",
          overflowX: isMaximized || showScrollbar ? "auto" : "hidden",
          scrollbarWidth: "thin",
          scrollbarColor: "#888 #f1f1f1",
        }}
      >
        <div
          style={{
            width:
              isMaximized || showScrollbar
                ? `${Math.max(
                    reportData.bar_chart.chart_data.length * 50,
                    chartContainerRef.current?.clientWidth || 0
                  )}px`
                : "100%",
            height: "100%",
            minWidth: "100%",
          }}
        >
          <Bar
            ref={chartRef}
            data={chartData}
            options={chartOptions}
            style={{
              width: "100%",
              height: "100%",
            }}
            redraw={true}
          />
        </div>
      </div>
    );
  };

  // Clean up tooltip on unmount
  useEffect(() => {
    return () => {
      const tooltipEl = document.getElementById("chartjs-tooltip");
      if (tooltipEl) {
        tooltipEl.remove();
      }
    };
  }, []);

  if (loading && !reportData) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="spinner-border text-primary"></div>
      </div>
    );
  }

  if (error)
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        Error: {error}
      </div>
    );
  if (!reportData)
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        No report data available
      </div>
    );

  // Calculate processed files count from migration progress if available
  const processedFiles = reportData?.migration_progress?.processed_files
    ? reportData.migration_progress.processed_files.split(" out of ")[0]
    : reportData?.card_and_summary_data?.successful_files +
      reportData?.["card_and_summary data"]?.failed_files;

  if (isMaximized) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "white",
          zIndex: 1050,
          padding: "20px",
          overflow: "auto",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "15px",
          }}
        >
          <h5
            className="card-title fw-bold dbcardsdesign mb-2 "
            style={{ fontSize: "14px" }}
          >
            Time Taken For Each File (Maximized View)
          </h5>
          <CustomTooltip
            content="Minimize"
            placement="left"
            fallbackPlacements={["bottom"]}
          >
            <button
              onClick={toggleMaximize}
              className="btn btn-sm btn-outline-secondary me-2 iconColor"
            >
              <i className="fa-solid fa-compress"></i>
            </button>
          </CustomTooltip>
        </div>
        {renderChart()}
      </div>
    );
  }

  return (
    <div
      id="#migreports"
      className="tab_content font-family-inter"
      style={{ height: "100vh", overflow: "hidden" }}
    >
      <div
        className="page-contentReport"
        style={{ height: "100%", overflowY: "auto", backgroundColor: "white" }}
      >
        <div className="container-fluid py-7">
          <div className="d-flex align-items-center">
            <Link
              to="/migration"
              className="ms-0 d-flex align-items-center text-muted"
              style={{ textDecoration: "none" }}
            >
              <i
                className="ri-arrow-left-s-line"
                style={{
                  fontSize: "24px",
                  color: "#202B3E",
                  marginLeft: "-7px",
                }}
              ></i>
              <span
                className="ms-0"
                style={{ fontSize: "14px", color: "#202B3E" }}
              >
                Back
              </span>
            </Link>
          </div>

          <h5 className="fw-bold mb-0">Reports</h5>

          <div className="page-title-right">
            <ol className="breadcrumb m-0 p-0">
              <li className="breadcrumb-item font-size-12">
                <Link
                  to="/migration"
                  className="text-muted"
                  style={{ color: "#202B3E", fontSize: "13px" }}
                >
                  Reports
                </Link>
              </li>
              <li className="breadcrumb-item font-size-12 p-0">
                <span style={{ color: "Black", fontSize: "13px" }}>
                  {reportData?.["card_and_summary data"]?.job_name}
                </span>
              </li>
            </ol>
          </div>
        </div>

        <div className="container-fluid h-100 d-flex flex-column" style={{padding:"0px 0px 0px 0px"}}>
          <div className="container-fluid px-0">
            <div className="row g-2 mt-1 mb-2 mx-0">
              <div className="col" style={{ minWidth: "200px" }}>
                <ExecutionStatusCard
                  jobStatus={reportData?.["card_and_summary data"]?.job_status}
                  loading={loading}
                />
              </div>
              <div className="col" style={{ minWidth: "200px" }}>
                <TotalFilesCard
                  total={reportData?.["card_and_summary data"]?.total_files}
                  processed={processedFiles}
                  loading={loading}
                />
              </div>
              <div className="col" style={{ minWidth: "200px" }}>
                <SuccessFilesCard
                  count={
                    reportData?.["card_and_summary data"]?.successful_files
                  }
                  loading={loading}
                />
              </div>
              <div className="col" style={{ minWidth: "200px" }}>
                <FailedFilesCard
                  count={reportData?.["card_and_summary data"]?.failed_files}
                  loading={loading}
                />
              </div>
              <div className="col" style={{ minWidth: "200px" }}>
                <ConversionRateCard
                  rate={reportData?.["card_and_summary data"]?.conversion_rate}
                  loading={loading}
                />
              </div>
            </div>
          </div>

        <div className="container-fluid px-1 py-1" style={{paddingBottom:"15px"}}>
  <div className="row g-2 align-items-stretch" style={{ minHeight: "100%" }}>
    {/* LEFT SIDE */}
    <div className="col-md-6 d-flex flex-column mb-2 " style={{marginTop:"4px"}}>
      {/* Migration Progress */}
      <div className="card border-0 card-migration mb-2 flex-fill" style={{ borderRadius: "8px" }}>
        <div className="card-body p-3">
          <h5
            className="card-title fw-bold mb-0 dbcardsdesign mb-2"
            style={{ fontSize: "14px" }}
          >
            Migration Progress
          </h5>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h6 className="mb-0" style={{ fontSize: "12px" }}>
              Migrated {reportData?.["migration_progress"]?.processed_files}
            </h6>
            <span
              className="badge"
              style={{
                fontSize: "12px",
                backgroundColor: "white",
                color: "black",
              }}
            >
              {reportData?.migration_progress?.percentage}
            </span>
          </div>
          <div className="progress mb-2" style={{ height: "8px" }}>
            <div
              className="progress-bar"
              role="progressbar"
              style={{
                width: reportData?.migration_progress?.percentage,
              }}
              aria-valuenow={parseInt(
                reportData?.migration_progress?.percentage || "0"
              )}
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
          <div className="d-flex justify-content-between">
            <h6
              className="mb-1 fw-semibold"
              style={{ fontSize: "12px", color: "#676973" }}
            >
              {(reportData?.migration_progress?.processed_files || "").replace(" out of ", "/")}
            </h6>
          </div>
        </div>
      </div>

      {/* Job Summary */}
      <div className="border-0 card-migration flex-fill" style={{ borderRadius: "8px" }}>
        <div className="card-body p-3">
          <h5
            className="card-title fw-bold mb-0 dbcardsdesign mb-2"
            style={{ fontSize: "14px" }}
          >
            Job Summary
          </h5>

          <div className="row mb-0">
            <div className="col-6">
              <p className="mb-1 fw-semibold" style={{ fontSize: "12px", color: "#6c757d" }}>
                Job Name
              </p>
              <p className="card-title mb-0" style={{ fontSize: "12px", color: "#202B3E" }}>
                {reportData?.["card_and_summary data"]?.job_name || "N/A"}
              </p>
            </div>
            <div className="col-6">
              <p className="mb-1 fw-semibold" style={{ fontSize: "12px", color: "#6c757d" }}>
                Source Database
              </p>
              <p className="card-title mb-0" style={{ fontSize: "12px", color: "#202B3E" }}>
                {reportData?.["card_and_summary data"]?.source_db || "N/A"}
              </p>
            </div>
          </div>
          <hr />

          <div className="row mb-2">
            <div className="col-6">
              <p className="mb-1 fw-semibold" style={{ fontSize: "12px", color: "#6c757d" }}>
                Destination Database
              </p>
              <p className="card-title mb-0" style={{ fontSize: "12px", color: "#202B3E" }}>
                {reportData?.["card_and_summary data"]?.target_db || "N/A"}
              </p>
            </div>
            <div className="col-6">
              <p className="mb-1 fw-semibold" style={{ fontSize: "12px", color: "#6c757d" }}>
                Job Start Time
              </p>
              <p className="card-title mb-0" style={{ fontSize: "12px", color: "#202B3E" }}>
                {reportData?.["card_and_summary data"]?.started_at || "N/A"}
              </p>
            </div>
          </div>
          <hr />

          <div className="row mb-2">
            <div className="col-6">
              <p className="mb-1 fw-semibold" style={{ fontSize: "12px", color: "#6c757d" }}>
                Job Status
              </p>
              <p className="card-title mb-0" style={{ fontSize: "12px", color: "#202B3E" }}>
                {reportData?.["card_and_summary data"]?.job_status || "N/A"}
              </p>
            </div>
            <div className="col-6">
              <p className="mb-1 fw-semibold" style={{ fontSize: "12px", color: "#6c757d" }}>
                Job End Time
              </p>
              <p className="card-title mb-0" style={{ fontSize: "12px", color: "#202B3E" }}>
                {reportData?.["card_and_summary data"]?.completed_at || "N/A"}
              </p>
            </div>
          </div>
          <hr />

          <div className="row">
            <div className="col-6">
              <p className="mb-1 fw-semibold" style={{ fontSize: "12px", color: "#6c757d" }}>
                Total Execution Time
              </p>
              <p className="card-title mb-0" style={{ fontSize: "12px", color: "#202B3E" }}>
                {reportData?.["card_and_summary data"]?.processing_time || "N/A"}
              </p>
            </div>
            <div className="col-6">
              <p className="mb-1 fw-semibold" style={{ fontSize: "12px", color: "#6c757d" }}>
                Conversion Rate
              </p>
              <p className="card-title mb-0" style={{ fontSize: "12px", color: "#202B3E" }}>
                {reportData?.["card_and_summary data"]?.conversion_rate || "N/A"}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* RIGHT SIDE */}
    <div className="col-md-6 d-flex mb-2 " style={{marginTop:"4px"}}>
      <div className=" border-0 card-migration w-100 d-flex flex-column" style={{ borderRadius: "8px" }}>
        <div className="card-body p-3 d-flex flex-column">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="card-title fw-bold mb-0 dbcardsdesign" style={{ fontSize: "14px" }}>
              Time Taken For Each File
            </h5>
            <CustomTooltip content="Maximize" placement="left" fallbackPlacements={["bottom"]}>
              <button
                onClick={toggleMaximize}
                className="btn btn-sm btn-outline-secondary me-2 iconColor"
              >
                <i className="fa-solid fa-compress"></i>
              </button>
            </CustomTooltip>
          </div>
          <div className="flex-grow-1">{renderChart()}</div>
        </div>
      </div>
    </div>
  </div>
</div>

        </div>
      </div>
    </div>
  );
};

export default ViewReportsPage;
